import LiveDot from '@/components/general/Badge/LiveDot';
import PageCard from '@/components/general/PageCard';
import { Pill } from '@/components/general/Pill';
import { avatarBg } from '@/functions/formats';
import MainIcons from '@/icons/main';
import React, { useState } from 'react';
import styles from './styles.module.css';
import { Car, getMoreViolations, Plate } from '@/commonTypes';
import PlateBadge from '@/components/pages/home/HomeContent/CarSwitcher/PlateBadge';
import PriceSection from '@/components/pages/wallet/WalletContent/WalletInfo/PriceSection';
import { StatusRow } from './StatusRow/StatusRow';
import { useLayoutContext } from '@/context/LayoutContext';
// import ReplaceTextFunction from '@/functions/ReplaceTextFunction';
// import { TransformPlateNumber } from '@/functions/TransformPlateNumber';
// import PlateCardHeader from './DropDownPlateCard/PlateCardHeader';
import DropDownPlateCard from './DropDownPlateCard';
import Button from '@/components/common/Button';
import { InqStatusTitles } from '@/api/global';
import DownloadButton from '@/components/pages/wallet/WalletContent/Invoices/StatementCard/DownloadButton';
import Loader from '@/components/common/Loader';

export default function MyPlatesList({
  data,
  plateBtnClass,
  showHead = false,
  getMoreViolations,
  count,
  callBackHistory,
  loadingViolations = false,
}: {
  data?: any;
  plateBtnClass?: string;
  showHead?: boolean;
  getMoreViolations?: getMoreViolations;
  count?: string | number;
  callBackHistory?: any;
  loadingViolations?: boolean;
}) {
  const [expanded, setExpanded] = useState<number | null>();
  const { priceSymbol } = useLayoutContext();
  const [loading, setLoading] = useState(false);

  // // const samplePlate1 = 'شخصي ايران 88 ــ 414ج87';
  // const samplePlate1 = 'شخصي ايران 11 ــ 636ق11';
  // const samplePlate2 = 'ایران ۸۸ - ۴۱۴ ج ۸۷';
  // const samplePlate3 = 'ایران ۶۵ - ۱۲۳ الف ۴۵';
  // const sampleRow = {
  //   plateChar: 'شخصي ايران 11 ــ 636ق11',
  //   complaintStatus: null,
  //   complaint: null,
  //   priceStatus: '1',
  //   paperId: '9622168000190',
  //   paymentId: '2730535813',
  //   price: 27305000,
  // };

  console.log('history0====', data);
  const renderItem = () => (
    <div className={styles.plates}>
      {data?.results?.map((plate: object, index: number) => (
        <DropDownPlateCard
          key={index}
          plate={plate}
          open={expanded === index}
          // onToggle={() => setExpanded(expanded === index ? -1 : index)}
          plateBtnClass={`${styles.plateBtnClass} ${plateBtnClass}`}
          //   aside={<>fe</>}
        >
          h
        </DropDownPlateCard>
      ))}
      {data?.results && data?.results?.length < Number(data?.items_count) && (
        <Button
          loading={loadingViolations}
          wrapperStyle="w-full flex"
          className={`btn btn-white squareButton mx-auto`}
          onClick={() => {
            if (getMoreViolations && data?.results?.length !== undefined) {
              getMoreViolations(data?.results?.length, data?.batch);
            }
          }}
        >
          بیشتر
        </Button>
      )}
      {(data?.status == InqStatusTitles.TransactionStatusPending ||
        data?.status == InqStatusTitles.TransactionStatusFailed) && (
        <div className={`card`}>
          {data?.status == InqStatusTitles.TransactionStatusPending && (
            <div className={`${styles.processingWrapper}`}>
              <div className={`${styles.processingContainer}`}>
                <Loader
                  className={`${styles.loader}`}
                  containerclassname={`${styles.loaderContainer}`}
                />
                <p className={`${styles.processingResult}`}>درخواست شما در صف قرار گرفت.</p>
              </div>
              {callBackHistory && (
                <DownloadButton>
                  <MainIcons.RefreshIcon
                    fill="var(--brand-dark)"
                    width={'19px'}
                    height={'19px'}
                    className={loading ? `spinIcon` : ''}
                    onClick={() => {
                      setLoading(true);
                      window.location.reload();
                    }}
                  />
                </DownloadButton>
              )}
            </div>
          )}
          {data?.status == InqStatusTitles.TransactionStatusFailed && (
            <p className={`${styles.errorResult}`}>خطا </p>
          )}
        </div>
      )}
    </div>
  );
  return (
    <>
      {showHead ? (
        <div className={``}>
          <PageCard
            title="پلاک‌های ثبت‌شده"
            text="برای مشاهدهٔ جزئیات روی هر پلاک بزنید"
            icon={<MainIcons.carIcon width="20px" height="20px" fill="var(--paper)" />}
            backgroundIcon={avatarBg(4)}
            className={`${styles.pageCard}`}
            aside={
              <Pill color="var(--green)" bg="var(--green-bg)">
                <LiveDot className={`${styles.pillDot}`} />
                استعلام زنده
              </Pill>
            }
          >
            {renderItem()}
          </PageCard>
        </div>
      ) : (
        <>{renderItem()}</>
      )}
    </>
  );
}
